import React from 'react';
import { testimonials } from '../data/angielski';
export function Testimonials() {
  // Hidden until authentic ANGIELSKI GOTOWY reviews are added in data/angielski.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-278" data-mp="3fym8yp543a6g">
      <div className="mx-auto max-w-6xl" data-id="element-279" data-mp="3azt57ofmmxjh">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-280" data-mp="3ayqat6j3icyt">
          Co mówią <em className="text-red-700" data-id="element-281" data-mp="3205zwrjs17l5">nauczyciele</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-282" data-mp="321zb8k5c4fzh">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-283" data-mp="2s1qb4v882aet">
              <div className="text-sm text-amber-500" aria-label="5 na 5 gwiazdek" data-id="element-284" data-mp="2s3jjqg2eb4pg">
                <span aria-hidden="true" data-id="element-285" data-mp="v8wtqb0hxmd8">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-286" data-mp="qa3mv1fpstm1">
                „{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-287" data-mp="h8ay1cwsipqp">
                <span className="font-semibold text-slate-900" data-id="element-288" data-mp="m5sy0dstxumk">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-289" data-mp="78k3xcc56cr5"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}